// extracted by mini-css-extract-plugin
module.exports = {"calendar":"Calendar-calendar-GrG88","calendarContent":"Calendar-calendarContent-2vrba"};